export function formatDuration(hours?: number | null): string | null {
  if (!hours || hours <= 0) return null
  if (hours < 1) return `${Math.round(hours * 60)} min`
  const rounded = Math.round(hours * 10) / 10
  return `${rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1)}h`
}

export function formatStudentCount(count?: number | null): string | null {
  if (!count || count <= 0) return null
  if (count >= 1000) return `${(count / 1000).toFixed(count >= 10000 ? 0 : 1)}k estudiantes`
  return `${count} ${count === 1 ? "estudiante" : "estudiantes"}`
}

export function formatProgressPercent(completed?: number | null, total?: number | null): number | null {
  if (!total || total <= 0) return null
  const value = Math.round(((completed ?? 0) / total) * 100)
  return Math.min(100, Math.max(0, value))
}
